<template>
    <div class="form-group" :class="{'has-error': errors.has('time') || errors.has('timezone')}">
        <label for="time" class="col-sm-2 control-label">Time of activity:</label>
        <div class="col-md-3 col-sm-4 time-picker">
            <time-picker v-validate.disable="timeEntry.isAuditEdit ? '' : 'required_time'" name="time" v-model="timeEntry.time" :controls="false" :readonly="timeEntry.isAuditEdit"/>
            <p class="text-danger" v-if="errors.has('time')">{{ errors.first('time') }}</p>
        </div>
        <div class="col-md-3 col-sm-4">
            <div class="select-dropdown">
                <select v-validate.disable="timeEntry.isAuditEdit ? '' : 'required'" name="timezone" class="form-control" v-model="timeEntry.timezone" :disabled="timeEntry.isAuditEdit">
                    <option value="PT">Pacific Time (Vancouver)</option>
                    <option value="MT">Mountain Time (Calgary)</option>
                    <option value="CT">Central Time (Winnipeg)</option>
                    <option value="ET">Eastern Time (Toronto)</option>
                    <option value="AT">Atlantic Time (Halifax)</option>
                    <option value="NST">Newfoundland Time (St John's)</option>
                </select>
                <i class="fa fa-chevron-down"></i>
            </div>
            <p class="text-danger" v-if="errors.has('timezone')">{{ errors.first('timezone') }}</p>
        </div>
    </div>
</template>

<script>
    import Vue from "vue";
    import { Validator } from 'vee-validate';

    Validator.extend('required_time', {
        getMessage: field => 'A valid time is required',
        validate: value => !isNaN(value) && value != ''
    });

    export default {
        inject: ['$validator'],
        data: function () {
            return {
                timeEntry: this.$store.state.timeEntry,
            };
        }
    };
</script>